function getGoogleMaps() {
  return window.google?.maps || null;
}

const CANADA_GEOCODER_BOUNDS = {
  south: 41.6,
  west: -141.1,
  north: 83.2,
  east: -52.5,
};

async function waitForGoogleMaps(timeoutMs = 10000) {
  const startedAt = Date.now();

  while (Date.now() - startedAt < timeoutMs) {
    const googleMaps = getGoogleMaps();

    if (googleMaps?.Geocoder) {
      return googleMaps;
    }

    await new Promise((resolve) => setTimeout(resolve, 100));
  }

  throw new Error("Google Maps JavaScript API is not available");
}

function buildCanadianGeocodeRequest(address) {
  const normalizedAddress = String(address || "").trim();

  if (!normalizedAddress) {
    throw new Error("Address is required");
  }

  const addressWithCountry = /\bcanada\b/i.test(normalizedAddress)
    ? normalizedAddress
    : `${normalizedAddress}, Canada`;

  return {
    address: addressWithCountry,
    bounds: CANADA_GEOCODER_BOUNDS,
    componentRestrictions: { country: "CA" },
    region: "ca",
  };
}

async function geocodeAddress(address) {
  const request = buildCanadianGeocodeRequest(address);

  const googleMaps = await waitForGoogleMaps();
  const geocoder = new googleMaps.Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode(request, (results, status) => {
      const location = results?.[0]?.geometry?.location;

      if (status !== "OK" || !location) {
        reject(new Error(`Geocoding failed: ${status}`));
        return;
      }

      resolve({
        lat: typeof location.lat === "function" ? location.lat() : location.lat,
        lng: typeof location.lng === "function" ? location.lng() : location.lng,
      });
    });
  });
}

export { buildCanadianGeocodeRequest, geocodeAddress };
